import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '../services/api';

/**
 * El cliente de consultas, en su propio modulo.
 *
 * Vive aqui y no dentro de `main.tsx` porque el puente de autenticacion
 * tambien lo necesita: cuando aparece un token nuevo hay que volver a pedir lo
 * que fallo por no tenerlo. Ese puente esta POR ENCIMA del
 * `QueryClientProvider` en el arbol, asi que no puede pedirlo con un hook.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // 401 y 403 no se reintentan: se resuelven renovando la sesion o
        // mostrando la pagina de acceso denegado, no insistiendo.
        if (error instanceof ApiError && (error.isUnauthorized || error.isForbidden)) {
          return false;
        }
        return failureCount < 2;
      },
    },
    mutations: { retry: false },
  },
});
